@if (breadcrumbs$ | async; as breadcrumbs) {
    <section>
        <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
    </section>
}

@if ((product$ | async) === undefined) {
    <div class="py-10">
        <div class="spinner mx-auto"></div>
    </div>
}

@if (product$ | async; as product) {
    <section>
        <app-products-single [product]="product" [categorySlug]="categorySlug"></app-products-single>
    </section>
}

@if (otherProducts$ | async; as othersProducts) {
    <section class="others-products">
        <div class="container-fluid container-xxl gx-sm-9 gx-lg-10 gx-xxl-0 pt-8 pb-8 pt-sm-14 pb-sm-12">
            <h3 class="mb-xl-6 mb-5 fs-12 fw-700 ls-2 font-secondary text-secondary text-uppercase">
                {{ 'PRODUCT.others_products' | translate }}
            </h3>
            <div class="d-none d-sm-block">
                <div class="swipper-custom-arrow-wrapper position-relative">
                    <div #swiper class="swiper" [class.is-client]="isClient">
                        <div class="swiper-wrapper">
                            @for (product of othersProducts; track product.slug) {
                                <div class="swiper-slide">
                                    <a [routerLink]="['/products', 'all', product.slug] | localize">
                                        <div app-product-thumbnail [product]="product"></div>
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center">
                        <div #swiperNavigationPrev class="swiper-custom-arrow-prev swiper-btn"></div>
                        <div #swiperNavigationNext class="swiper-custom-arrow-next swiper-btn"></div>
                    </div>
                </div>
            </div>
            <div class="d-sm-none">
                <div class="row gx-3">
                    @for (product of otherProducts$ | async; track product) {
                        <div class="col-6 mb-3">
                            <a [routerLink]="['/products', 'all', product.slug] | localize">
                                <div class="item" app-product-thumbnail [product]="product"></div>
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>
    </section>
}
